<template>
	<div class="PageSettings">
		<div class="row">
			<div class="col-xs-12">
				<div class="row">
					<div class="col-xs-6">croppa</div>
					<div class="col-xs-6"><switches :color="croppa ? 'green' : 'red'" v-model="croppa"></switches></div>
				</div>
				<div class="row">
					<div class="col-xs-6">media_store</div>
					<div class="col-xs-6"><switches :color="media_store ? 'green' : 'red'" v-model="media_store"></switches></div>
				</div>
				<div class="row">
					<div class="col-xs-6">livepreview</div>
					<div class="col-xs-6"><switches :color="livepreview ? 'green' : 'red'" v-model="livepreview"></switches></div>
				</div>
				<div class="row">
					<div class="col-xs-6">inlinemod</div>
					<div class="col-xs-6"><switches :color="inlinemod ? 'green' : 'red'" v-model="inlinemod"></switches></div>
				</div>
				<div class="row">
					<div class="col-xs-6">auto_hide_notifications</div>
					<div class="col-xs-6"><switches :color="auto_hide_notifications ? 'green' : 'red'" v-model="auto_hide_notifications"></switches></div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import Switches from 'vue-switches';
export default {
	name: 'PageSettings',
	components: {
		Switches
	},
	computed: {
		croppa: {
			get(){
				return this.$store.getters['features/croppa'];
			},
			set(value){
				this.$store.commit('features/SET_CROPPA', value);
			}
		},
		media_store: {
			get(){
				return this.$store.getters['features/media_store'];
			},
			set(value){
				this.$store.commit('features/SET_MEDIA_STORE', value);
			}
		},
		livepreview: {
			get(){
				return this.$store.getters['features/livepreview'];
			},
			set(value){
				this.$store.commit('features/SET_LIVEPREVIEW', value);
			}
		},
		inlinemod: {
			get(){
				return this.$store.getters['features/inlinemod'];
			},
			set(value){
				this.$store.commit('features/SET_INLINEMOD', value);
			}
		},
		auto_hide_notifications: {
			get(){
				return this.$store.getters['features/auto_hide_notifications'];
			},
			set(value){
				this.$store.commit('features/SET_AUTO_HIDE_NOTIFICATIONS', value);
			}
		},

	},
}
</script>



// WEBPACK FOOTER //
// src/pages/PageSettings.vue